module.exports = __webpack_public_path__ + "img/744.4efb0b7d.jpg";